import IconButtonMui from '@mui/material/IconButton';

import { styled } from '@mui/material/styles';
import theme from 'initializers/src/theme';

export const JEGoogleSearchWrapper = styled('div', {
  label: 'JEGoogleSearchWrapper',
})(() => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '100%',
}));

export const JEGoogleSearchIconButton = styled(IconButtonMui, { label: 'JEGoogleSearchIconButton' })(() => ({
  padding: 2,
  color: theme.palette.primary.main,

  '& .MuiSvgIcon-root': {
    fontSize: 18,
  },
}));

export const JEGoogleSearchValue = styled('div', { label: 'JEGoogleSearchValue' })(() => ({
  flexGrow: 1,
  maxWidth: 'calc( 100% - 16px )',
}));
